const plans = new Object({
    free: {
        name: "Free",
        price: 'Free',
        predictionsLimit: 500,
        datasetsLimit: 1,
        datasetRowsLimit: 1000,
        modelsLimit: 2,
        projectsLimit: 2,
        modelTrainingsLimit: 10,
        apisLimit: 1
    },
    starter: {
        name: "Starter",
        predictionsLimit: 500,
        datasetsLimit: 1,
        datasetRowsLimit: 1000,
        modelsLimit: 10,
        projectsLimit: 5,
        modelTrainingsLimit: 50,
        apisLimit: 1
    },
    pro: {
        name: "Pro",
        predictionsLimit: 160000,
        datasetsLimit: 100,
        datasetRowsLimit: 10000,
        modelsLimit: 1000,
        projectsLimit: 1000,
        modelTrainingsLimit: 200,
        apisLimit: 50
    },
    enterpriseDefault: {
        name: "Enterprise",
        predictionsLimit: 160000,
        datasetsLimit: 100,
        datasetRowsLimit: 100000,
        modelsLimit: 1000,
        projectsLimit: 1000,
        modelTrainingsLimit: 200,
        apisLimit: 50
    },
})

export default plans